import { __awaiter } from 'tslib';
import * as Long from 'long';
import { im_proto } from '../../proto/index.js';
import '../../core/consts.js';
import '../../core/metrics/logger.js';
import { BaseApiManager } from '../../core/plugin/BaseApiManager.js';
import '../../core/metrics/monitor.js';
import '../../core/service/RuntimeContext.js';
import 'json-long';
import 'moize';
import '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../../core/network/NetworkItem.js';
import '../../adapter/manager/AdapterManager.js';
import '../../adapter/manager/types.js';
import '../../core/utils/ticker.js';
import '../../adapter/abstract/IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import '../../core/metrics/trackerTypes.js';
import '../../core/model/CommandMessage.js';

class StorageApiManager extends BaseApiManager {
    GetMessagesCheckInfoInConversation(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                get_messages_checkinfo_in_conversation_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: Long.fromValue(params.conversationShortId),
                    conversation_type: params.conversationType,
                    cursor_reverse_begin: Long.fromValue(params.cursorReverseBegin),
                    cursor_reverse_end: Long.fromValue(params.cursorReverseEnd),
                    expect_msg_total_count: params.expectedTotalMessageCount
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.GET_MESSAGES_CHECKINFO_IN_CONVERSATION, { inboxType: params.inboxType })).get_messages_checkinfo_in_conversation_body;
        });
    }
    GetConversationsCheckInfo(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({});
            return (yield this.send(reqBody, im_proto.IMCMD.GET_CONVERSATIONS_CHECKINFO, { inboxType: params.inboxType })).get_conversations_checkinfo_body;
        });
    }
}

export { StorageApiManager };
//# sourceMappingURL=StorageApiManager.js.map
